import { useState, useEffect } from 'react';

interface RecordingTimerProps {
  startTime: number | null;
  className?: string;
}

export function RecordingTimer({ startTime, className = '' }: RecordingTimerProps) {
  const [elapsedTime, setElapsedTime] = useState('00:00');

  useEffect(() => {
    if (!startTime) {
      setElapsedTime('00:00');
      return;
    }

    const updateTimer = () => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const minutes = Math.floor(elapsed / 60);
      const seconds = elapsed % 60;
      setElapsedTime(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    };

    // Update immediately
    updateTimer();

    // Update every second
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  if (!startTime) {return null;}

  return (
    <span className={`font-mono text-sm ${className}`}>
      {elapsedTime}
    </span>
  );
}